import { useUploadPjs } from '@mairistem/comptabilite';

import { FicheBar } from '@mairistem/fiche';
import React from 'react';
import type { Projet } from '@/src/interfaces/projet';

interface ProjetFicheProps {
	identifiant: number;
	onSaved: (
		data: Projet,
		status?: { created?: boolean; updated?: boolean; deleted?: boolean },
	) => void;
}

const ProjetFicheBarConsumer = (props: ProjetFicheProps) => {
	const { identifiant, onSaved, ...handlers } = props;
	const uploadPjs = useUploadPjs();

	const handleSaved = (
		data: Projet,
		status?: { created?: boolean; updated?: boolean; deleted?: boolean },
	) => {
		onSaved(data, status);
		uploadPjs(data?.identifiant);
	};

	return (
		<FicheBar
			key="ficheProjet"
			type="projet"
			identifiant={identifiant}
			canDraft={false}
			onSaved={handleSaved}
			{...handlers}
		/>
	);
};

export default ProjetFicheBarConsumer;
